var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4351_6826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4351_6826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4351_6826)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.6667,
    height: 45,
    fill: "#4774C4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4351_6826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14,
    y: -21,
    width: 60,
    height: 74,
    fill: "#112236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4351_6826",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4351_6826",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADWklEQVR4nO2dPW7UQBxHH2ySa0QEquQQ3AKQQFyDEuho+FJOgERBRw8VSJyA0EZJOupQICUIio0lK3jtGc+Mf/Pxf9J0u87Me/bGu/kYMAzDMAzDMAzDCOcAeA0cAb+Av+LxLO1y82EHOAQu0UtvLsIO8Bm96GYjHKIX3GyEA/J82Wkmwhv0Un3HiyQmRPxAL/T6Gd7UlXCOXnp/ADxxfGwVV4Ja+FAAaCiCWvimANBIBLXwsQDQQAS18KkAUHkEtXCXAFBxBLVw1wBQaQS1cJ8AUGEEtXDfAFBZBLXwOQGgoghq4XMDQCUR1MJDAkAFEdTCQwNA4RHUwmMEgIIjqIXHCgCFRlALjxkACoygFh47ABQWQS08RQBwjyBHLTylEJcIctTCUwuZiiBHLXwJIWMRgtgKPUCGZHFWunJTPYHWsQBiLIAYCyDGAoixAGJqD3B2NapG/cZr0zgDbgO7wHHCryNHLXpMfkfKCHLUsqfkd6SKIEct3EV+R4oIcmIt5CfwJ+D5p8Cew3z3rh5rAXqjk/eYeRFc5cP6A8iPkeZdRYDrLxsPgIuA54+xAt5HmHM1ATbJc42gll90gCl5UxFykF9sAFd5myLkIr/IAD7y4P8IOckvLoCv/I4uQm7yiwrgc6s4xD2P528BHxznVTwpz/w5+J75xVOy/CYC3F1oHj4vO00FOAFuTRxjBbwDHs2cQ8g33OJxWeRYhL68S/wjhN7tFI/rQociDMnziRDjVrN4fBbbjzAmzyVCrPv84vFd8Alwh2l5YxFivskKXZ+cOYv+7fi4C+D+ta83927HAswc/StB8Xl+8wG6K+Ehcc/8LALcCD1AjEmImXIwtb4gh7X/Zlz2WAAxFkBMDX8jFuP7mAy7AsRYADEWQIwFEGMBxFgAMTUE2FVPIIQYAc4jHCOEr0z/zLmP6/8BivVhXX889ZinM0eek0gxjvG7Ely3OYk5km2Z8kqwmKFxStorIWQkOfM79slnG6scr4RFNgt6u8BCSoyw2E5N28CnhAspMcLi22Rts97Uzefvu2qNIN2jbB94CXxHv8eYIkI1G8SpCLk7Snq30xJzIpj8yPhEMPmJcIlg8hMzFsHkL8RQBJO/MP0I0eSvYh2oAb6x/hWYL8DzWAf9B0M/wESc2uMjAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a94000f0f4451a8f66b9ef90848fb888.svg";
export { ForwardRef as ReactComponent };